import { defineStore } from 'pinia';
import {validateAllStepsTill} from "./validation";

export const useFlexiblePackagingStore = defineStore('flexible-packaging', {
    state: () => ({
        page: 'FlexiblePackagingCategorySelector',
        currentStep: 0,

        data: {
            category: "stand_up_pouches",
            pouchType: "2_side_seal_pouch",
            unwind: null,

            pouch_size: '3" x 3"',
            hole_in_pouch: 'no_hole',
            zipper: 'none',
            tear_notch: 'none',
            rounded_corners: 'yes',
            seal_width: '05_mm',
            pouch_valve: 'none',
            material: 'gloss',

            sku: '',

            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            company: '',
            industry: '',
            country: '',
            city: '',
            order_quantity: '2000',
            how_did_you_find_us: '',
        },

        steps: [
            { component: "FlexiblePackagingCategorySelector", stepTitle: window.$trans('storefront::flexible_packaging.choose_your_package'), enabled: true, validated: true, header: window.$trans('storefront::flexible_packaging.your_selection') },
            { component: "FlexiblePackagingPouchTypeSelector", stepTitle: window.$trans('storefront::flexible_packaging.type_of_pouch'), enabled: true, validated: true, header: window.$trans('storefront::flexible_packaging.your_selection') },
            { component: "FlexiblePackagingQuestionnaire", stepTitle: window.$trans('storefront::flexible_packaging.features_selection'), enabled: true, validated: true, header: window.$trans('storefront::flexible_packaging.your_selection') },
            { component: "FlexiblePackagingSku", stepTitle: window.$trans('storefront::flexible_packaging.sku'), enabled: true, validated: false, header: window.$trans('storefront::flexible_packaging.skus') },
            { component: "FlexiblePackagingFileUpload", stepTitle: window.$trans('storefront::flexible_packaging.file_upload'), enabled: true, validated: true, header: window.$trans('storefront::flexible_packaging.submit_your_artwork') },
            { component: "FlexiblePackagingDetailForm", stepTitle: window.$trans('storefront::flexible_packaging.contacts'), enabled: true, validated: false, header: window.$trans('storefront::flexible_packaging.a_couple_more_things_before_completing') },
            { component: "FlexiblePackagingSummary", stepTitle: window.$trans('storefront::flexible_packaging.summary'), enabled: true, validated: true, header: window.$trans('storefront::flexible_packaging.review') },
            { component: "FlexiblePackagingQuerySent", stepTitle: window.$trans('FlexiblePackagingQuerySent'), enabled: true, validated: true, header: window.$trans('storefront::flexible_packaging.thank_you_for_your_interest') },
        ],

        currentQuestion: 1,
        questions: [
            { componentType: "pouch_size", question: window.$trans('storefront::flexible_packaging.pouch_size_question'), component: "SidePlowSizeSelector" },
            { componentType: "hole_in_pouch", question: window.$trans('storefront::flexible_packaging.hang_hole_question'), component: "HoleInPouch" },
            { componentType: "zipper", question: window.$trans('storefront::flexible_packaging.zipper_question'), component: "Zipper" },
            { componentType: "tear_notch", question: window.$trans('storefront::flexible_packaging.tear_notch_question'), component: "TearNotch" },
            { componentType: "rounded_corners", question: window.$trans('storefront::flexible_packaging.rounded_corners_question'), component: "RoundedCorners" },
            { componentType: "seal_width", question: window.$trans('storefront::flexible_packaging.seal_width_question'), component: "SealWidth" },
            { componentType: "pouch_valve", question: window.$trans('storefront::flexible_packaging.valve_question'), component: "PouchValve" },
            { componentType: "material", question: window.$trans('storefront::flexible_packaging.material_question'), component: "Material" }
        ],

        files: [],
        mediaOptions: {
            mimes: '.png,.jpg,.jpeg,.svg,.pdf',
            mimeTypes: null,
            maxFileCount: 10,
            maxFileSize: 32,
        },

        loading: false,

        errors: {},
    }),
    actions: {
        changeComponentByType(componentType, newComponent) {
            const questionIndex = this.questions.findIndex(question => question.componentType === componentType);

            if (questionIndex !== -1) {
                this.questions[questionIndex].component = newComponent;
            }
        },
        hasError(name) {
            return this.errors.hasOwnProperty(name);
        },
        getError(name) {
            if (!this.errors.hasOwnProperty(name)) return;
            return this.errors[name];
        },
        removeError(name) {
            if (!this.errors.hasOwnProperty(name)) return;
            delete this.errors[name];
        },
        gotoStep(key) {
            this.currentStep = key;
            this.onStepChange();
        },
        nextStep() {
            this.currentStep++;
            this.onStepChange();
        },
        previousStep() {
            this.currentStep--;
        },
        showFormSubmitErrors(errors) {
            let errorData = {};
            if (typeof errors.errors !== 'undefined') {
                Object.keys(errors.errors).forEach(key => {
                    if (typeof errors.errors[key] === 'string') {
                        errorData[key] = errors.errors[key];
                    } else if (Array.isArray(errors.errors[key])) {
                        errorData[key] = errors.errors[key][0];
                    }
                });
            }
            this.errors = errorData;
        },
        onStepChange() {
            validateAllStepsTill({_store: this, maxStep: this.currentStep})

            for (const [key, step] of Object.entries(this.steps)) {
                if (step.validated === false && this.currentStep > key) {
                    this.currentStep = key;
                }
            }
        }
    },
});
